import React from 'react';
import t from '../utils/labels';

const Footer = () => <footer>
	{t`Copyright`} © 2017-{new Date().getUTCFullYear()} {t`Food footer`}
</footer>;

export default Footer;